import {
  Button,
  CircularProgress,
  Fade,
  Grid,
  InputAdornment,
  Typography,
} from "@material-ui/core";
import { Formik, Form } from "formik";
import React from "react";
import Logo from "../../img/loginLogo.png";
import TextFieldWrapper from "../../components/TextField";
import {
  validationSchema,
  initialValues,
} from "../../validation/LoginResetPassValidation";
import { useHistory } from "react-router-dom";
import { connect } from "react-redux";
import { Visibility } from "@material-ui/icons";
import { ResetPassword } from "../../redux/Login/LoginActions";
import Store from "../../redux/Store";
import { authUnauthorizedMessage } from "../../redux/Login/LoginActionCreators";
const LoginResetPassword = ({ authError, loading }) => {
  const history = useHistory();
  const [showPass, setShowPass] = React.useState(true);
  let [open, setOpen] = React.useState(false);

  React.useLayoutEffect(() => {
    setOpen(true);

    return () => {
      setOpen(false);
    };
  }, []);
  React.useEffect(() => {
    Store.dispatch(authUnauthorizedMessage(""));
  }, []);

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      validateOnMount
      onSubmit={(values, props) => {
        props.resetForm();
        ResetPassword(values).then((res) => {
          if (!res) return;
          history.push("/");
        });
      }}
    >
      {(formik) => {
        return (
          <Form>
            <Fade in={open} timeout={500}>
              <Grid
                container
                justifyContent="center"
                alignItems="center"
                style={{ height: "100vh", backgroundColor: "#F2F2F6" }}
              >
                <Grid
                  container
                  item
                  justifyContent="center"
                  alignItems="center"
                  direction="column"
                  spacing={4}
                  xs={10}
                  sm={6}
                  md={5}
                  lg={4}
                  xl={3}
                  style={{
                    backgroundColor: "white",
                    borderRadius: "20px",
                    boxShadow: "0 3px 6px rgba(0,0,0,0.1)",
                    paddingTop: "51px",
                    paddingBottom: "51px",
                  }}
                >
                  <Grid
                    item
                    md={10}
                    xs={12}
                    container
                    justifyContent="center"
                    spacing={3}
                  >
                    <Grid item xs={12} container justifyContent="center">
                      <img src={Logo} alt="logo" />
                    </Grid>
                    <Grid item xs={12} container justifyContent="center">
                      <Typography variant="button">
                        رمز جدید را وارد کنید
                      </Typography>
                    </Grid>
                    <Grid item xs={12} container justifyContent="center">
                      <Typography variant="button" color="secondary">
                        {authError}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} container justifyContent="center">
                      <TextFieldWrapper
                        name="password"
                        label="رمز عبور"
                        type={showPass ? "password" : null}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <Visibility
                                color="primary"
                                fontSize="small"
                                onClick={() => setShowPass(!showPass)}
                                style={{ cursor: "pointer" }}
                              />
                            </InputAdornment>
                          ),
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} container justifyContent="center">
                      <TextFieldWrapper
                        name="confirm_password"
                        label="تکرار رمز عبور "
                        type={showPass ? "password" : null}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <Visibility
                                color="primary"
                                fontSize="small"
                                onClick={() => setShowPass(!showPass)}
                                style={{
                                  cursor: "pointer",
                                }}
                              />
                            </InputAdornment>
                          ),
                        }}
                      />
                    </Grid>

                    <Grid item xs={12} container justifyContent="center">
                      <Button
                        fullWidth
                        variant="contained"
                        color="primary"
                        disabled={!formik.isValid || loading}
                        type="submit"
                      >
                        {!loading ? (
                          "  تایید"
                        ) : (
                          <CircularProgress
                            style={{
                              color: "white",
                              height: 24,
                              width: 24,
                            }}
                          />
                        )}
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Fade>
          </Form>
        );
      }}
    </Formik>
  );
};
const mapStateToProps = (props) => {
  const { loginReducer } = props;
  const { authError, loading } = loginReducer;
  return { authError, loading };
};

export default connect(mapStateToProps)(LoginResetPassword);
